/**
 * The languages the DM speaks (the settings and creation surfaces).
 *
 * Mirrors `src/quest-v2-api/quest/static/i18n/` — three bundles, `en` / `de` / `ua`, and the
 * API's own note that English is the only fully supported one. There is no endpoint that
 * lists them: `GET /translations` serves *a* locale and the set is a deployment fact, so this
 * list is a copy and is allowed to be. What it must not do is *hide* a locale the server
 * knows about, which is why `localeLabel` falls through to the code rather than to "unknown".
 *
 * The label is in the language it names. A player looking for German is looking for
 * *Deutsch*, and a settings list that reads "German" in English is a list they have to
 * translate before they can use it.
 */
export interface LocaleOption {
  code: string;
  label: string;
}

export const LOCALES: readonly LocaleOption[] = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'ua', label: 'Українська' },
];

export function localeLabel(code: string): string {
  return LOCALES.find((locale) => locale.code === code)?.label ?? code;
}
